/**
 * Paleta de identidad de agente — claro/oscuro. Validada WCAG (ADR-280 §4).
 * MVP: mapa en front. Futuro (#281): campo `color` por agente en el descriptor.
 */

// Asignados (bloqueados). Anne/Cassie fijos; Jimmy/Jorge/Seo confirmados por Guo 2026-07-15.
export const AGENT_COLORS = {
  anne:   { light: '#007A33', ink: '#007A33', dark: '#37A75F' },
  cassie: { light: '#1FA6A6', ink: '#177C7C', dark: '#3FC8D1' },
  jimmy:  { light: '#C08A1E', ink: '#9A6E18', dark: '#E8C25A' },
  jorge:  { light: '#2A4B8C', ink: '#2A4B8C', dark: '#7FA0E0' },
  seo:    { light: '#7A3FA6', ink: '#7A3FA6', dark: '#C79BEA' }, // violeta — CONFIRMADO
}

// Reserva ordenada para los PRÓXIMOS agentes (nº 6→11). Validada WCAG claro+oscuro
// (ADR-280 §4.4). No se asigna a mano: la reparte resolveAgentPalette() en orden.
export const AGENT_COLOR_RESERVE = [
  { light: '#B23A5B', ink: '#B23A5B', dark: '#E88AA3' }, // rosa
  { light: '#5C7A1E', ink: '#5C7A1E', dark: '#A6C25A' }, // oliva
  { light: '#4A3FA0', ink: '#4A3FA0', dark: '#A79BEA' }, // índigo
  { light: '#B4531E', ink: '#B4531E', dark: '#E89A6A' }, // siena
  { light: '#A0398C', ink: '#A0398C', dark: '#D98FCB' }, // magenta
  { light: '#1E7FB4', ink: '#1B72A2', dark: '#6FC2EA' }, // cerúleo
]

// Cola (>11 agentes): matiz por rotación de ángulo áureo con L/C fijos por tema →
// nunca se queda sin color y mantiene separación.
function generado(k) {
  const h = (200 + k * 137.508) % 360
  return { light: hslToHex(h, 58, 32), ink: hslToHex(h, 58, 32), dark: hslToHex(h, 62, 70) }
}

function hslToHex(h, s, l) {
  s /= 100; l /= 100
  const k = n => (n + h / 30) % 12
  const a = s * Math.min(l, 1 - l)
  const f = n => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))
  const toHex = n => Math.round(255 * f(n)).toString(16).padStart(2, '0')
  return `#${toHex(0)}${toHex(8)}${toHex(4)}`
}

// Resuelve la paleta para los agentes de la sesión. DETERMINISTA: un agente conserva
// su color aunque entre o salga otro (se ordena por id y se reparte la reserva).
// Prioridad: agent.color (descriptor, futuro) → asignado → reserva → generado.
export function resolveAgentPalette(agents = []) {
  const out = {}, pending = []
  for (const a of agents) {
    if (a.color) out[a.id] = a.color // objeto {light,ink,dark}
    else if (AGENT_COLORS[a.id]) out[a.id] = AGENT_COLORS[a.id]
    else pending.push(a.id)
  }
  pending.sort()
  pending.forEach((id, i) => { out[id] = AGENT_COLOR_RESERVE[i] ?? generado(i - AGENT_COLOR_RESERVE.length) })
  return out
}

export function agentColorOf(palette, id, theme /* 'light'|'dark' */) {
  const c = palette[id]
  return c ? (theme === 'dark' ? c.dark : c.ink) : null
}
